'use es6';

import { createContext } from 'react';
import { Record } from 'immutable';
import PropTypes from 'prop-types';

/**
 * Context for settings/storing information about an object preview
 *
 * @example
 *
 * const { setPreviewConfig, closeSidebar } = useContext(PreviewConfigContext);
 *
 * const handleOpen = () => {
 *   setPreviewConfig(
 *     PreviewConfigRecord({
 *       objectTypeId,
 *       objectId,
 *     })
 *   );
 * };
 *
 * const handleClose = () => {
 *   closeSidebar();
 * }
 *
 * @example - if you're on the record page for a CONTACT with objectID 123, but viewing a preview
 * for a TICKET with objectId 456, the fromObjectType would be CONTACT and the fromObjectId would be 123
 *
 * const { setPreviewConfig, fromObjectType, fromObjectId } = useContext(PreviewConfigContext);
 *
 *
 * @param {object} value                              the context value
 * @param {Function} value.setPreviewConfig           the callback to set the preview config for a given object
 * @param {Function} value.closeSidebar               function to close the preview sidebar
 * @param {string} value.fromObjectType               the type of object that the preview was opened from
 * @param {string} value.fromObjectId                 the id of object that the preview was opened from
 */

export const PreviewConfigContext = /*#__PURE__*/createContext(null);
PreviewConfigContext.Provider.propTypes = {
  value: PropTypes.shape({
    setPreviewConfig: PropTypes.func.isRequired,
    closeSidebar: PropTypes.func.isRequired,
    fromObjectType: PropTypes.string.isRequired,
    fromObjectId: PropTypes.string.isRequired
  }).isRequired
};
export const PreviewConfigRecord = Record({
  objectTypeId: null,
  objectId: null
});